import { render, staticRenderFns } from "./radioSubject.vue?vue&type=template&id=c8364ea4&scoped=true"
import script from "./radioSubject.vue?vue&type=script&lang=js"
export * from "./radioSubject.vue?vue&type=script&lang=js"
import style0 from "./radioSubject.vue?vue&type=style&index=0&id=c8364ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8364ea4",
  null
  
)

export default component.exports